import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";
const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  width: 100%;
  padding: 30px 30px;
`;
const Icon = styled.div`
  width: 58px;
  height: 58px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  margin-bottom: 26px;
`;
const Text = styled.div`
  text-align: center;
  font-size: 22px;
`;

const Error = (props) => {
  return (
    <Wrap>
      <Text>{props.message}</Text>
    </Wrap>
  );
};

Error.propTypes = {
  message: PropTypes.string,
};

export default Error;
